import * as React from 'react';
// import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter as Router } from 'react-router-dom';
import { postError } from 'wisestep-api';
import { Spinner } from 'wisestep-base';

// import ErrorLogger from './ErrorLogger';

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  // const navigate = useNavigate();

  window.onerror = (
    event: Event | string,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: Error
  ) => {
    postError({
      message: event,
      url: document.URL,
      lineNo: lineno,
      colno: colno,
      stack: error?.stack,
    });
  };

  return (
    <React.Suspense fallback={<Spinner />}>
      {/* <ErrorBoundary
        FallbackComponent={({ error }) => <ErrorLogger error={error} pageRefresh={true} />}
      > */}
      <Router>{children}</Router>
      {/* </ErrorBoundary> */}
    </React.Suspense>
  );
};
